/**
 * Created by JackCui on 2021/3/31
 */

/**
 * 缓存用户信息和所属组织信息
 * @type {{userInfo: {}, organizationInfo: {}}}
 */
const USER_INFO = {
  userInfo: {},
  organizationInfo: {}
}

/**
 * 递归查询所属组织 接口返回的是整个树
 * @param user
 * @returns {{}|*}
 */
const organizationHandle = (user) => {
  const handle = (orgModel) => {
    const {organizationModel} = orgModel
    if (organizationModel) {
      return handle(organizationModel)
    }
    return orgModel
  }

  // 供应商端没有组织 需要判断一下
  if (!user.organizationModel) {
    return {}
  }

  return handle(user)
}

/**
 * 暴露出去的获取用户信息和组织接口 返回的参数固定且是新的对象 外部不会修改缓存
 * @returns {null|{loginName: *, name: *, id: *}}
 */
export const getUserInfo = () => {
  // TODO 这里用户id有  userId 和 id (供应商端为id, 采购商端为userId) 需要容错处理
  const {loginName, name, userId, id, code} = USER_INFO.userInfo
  if (!userId && !id) {
    return null
  }
  return {loginName, name, id: userId || id, code}
}

export const getOrganization = () => {
  const {code, id, name} = USER_INFO.organizationInfo
  if (!id) {
    return null
  }
  return {code, id, name}
}

/**
 * 存放用户信息 依赖外部getLoginUser接口
 * @param user
 */
export const setUser = (user) => {
  USER_INFO['userInfo'] = user
  USER_INFO['organizationInfo'] = organizationHandle(user)
}
